export default __webpack_public_path__ + "static/media/human.832c0ced.svg";